import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { useAuth } from '../../contexts/AuthContext';

export function PermissionProtectedRoute({ children, requiredPermission, requiredCategory }) {
  const { hasPermission } = usePermissions();
  const { currentAgent } = useAuth();

  // Check permission if required
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check category if required
  if (requiredCategory) {
    const category = currentAgent?.category || 'POP';
    if (category !== requiredCategory) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
